import React from 'react'
import { SelfSignUpForm } from 'front-end/src/pages/auth/self-signup/SelfSignUpForm'
import { WithSelfSignupFormik } from 'front-end/src/pages/auth/self-signup/WithSelfSignupFormik'
import { AdditionalInfoController } from './AdditionalInfoController'
import { useLoginContext } from 'front-end/src/pages/auth/login/LoginContext'
import { t } from '@lingui/macro'
import HeadTitle from 'front-end/src/components/common/head/HeadTitle'
import { observer } from 'mobx-react'
import {
  SelfSignupFormFieldsContext,
  SelfSignupFormFieldsContextType
} from '../self-signup/SelfSignupFormFieldsContext'
import { OrganisationRoleEnum } from 'front-end/src/graphql/public/PublicSchemaTypes'

type AdditionalInfoProps = {
  fieldsContext: SelfSignupFormFieldsContextType
  submit: () => Promise<boolean>
}

export const AdditionalInfo: React.FC<AdditionalInfoProps> = observer(
  ({ fieldsContext, submit }) => {
    const ctx = useLoginContext()

    return (
      <SelfSignupFormFieldsContext.Provider value={fieldsContext}>
        <HeadTitle title={t`Additional data`} />
        <AdditionalInfoController submit={submit}>
          {(onFormSubmit, signupLoading) => (
            <WithSelfSignupFormik onSubmit={onFormSubmit}>
              <SelfSignUpForm
                readOnly={
                  !ctx.organisation?.can_students_update_profile &&
                  !(
                    ctx.userData?.organisation_role ===
                    OrganisationRoleEnum.ADMIN
                  )
                }
                signupLoading={signupLoading}
                defaultValues={ctx.userData}
              />
            </WithSelfSignupFormik>
          )}
        </AdditionalInfoController>
      </SelfSignupFormFieldsContext.Provider>
    )
  }
)

AdditionalInfo.displayName = 'AdditionalInfo'
